/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const {
  withI18nTranslation,
} = require('./src/components/hoc/withI18nTranslation');

exports.wrapPageElement = withI18nTranslation;

exports.onInitialClientRender = () => {
  console.log("gatsby exports.onInitialClientRender");
  
  if (typeof window !== "undefined" && window.location.pathname === "/"|| typeof window !== "undefined" &&  window.location.pathname === "/de/") {
    const callGeoplugin = async () => {
      try {
        const response = await fetch(
          'https://api.ipgeolocation.io/ipgeo?apiKey=9b51f3e5aa9f4c02a6ae2d6746e5eede'
        );
        const body = await response.json();
        const countryCode = body.country_code2;

        console.log("Detected Country:", countryCode);

        if (countryCode === "CH") {
          window.location.replace("/ch/");
        }  else if (countryCode === "GB") {
          window.location.replace("/en/");
        } else if (countryCode === "FR") {
          window.location.replace("/fr/");
        } else if (countryCode === "US") {
          window.location.replace("/us/");
        } else if (countryCode === "ES") {
          window.location.replace("/es/");
        } else {
          // Default fallback
       //   window.location.replace("/de/");
        }
      } catch (err) {
        console.error("Geo redirect failed", err);
        // Fallback to default locale if geolocation fails
       // window.location.replace("/de/");
      }
    };

    callGeoplugin();
  }
};
